"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DropdownHeader = DropdownHeader;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactMintl = require("@godaddy/react-mintl");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _enums = require("./enums");
function DropdownHeader({
  loggedIn,
  name,
  preset
}) {
  if (loggedIn && name) {
    return name;
  }
  return /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
    id: preset === 'internal-header' ? _enums.golf.internalModeTitle : _enums.golf.title
  });
}
DropdownHeader.propTypes = {
  loggedIn: _propTypes.default.bool,
  name: _propTypes.default.string,
  preset: _propTypes.default.string
};
var _default = exports.default = DropdownHeader;